import { Box, Link, LinkProps, Typography, TypographyProps, useTheme, useMediaQuery } from '@methanesat/ui-components';
import { ReactNode } from 'react';
import { slugify } from '../../../../utils';

export type DataRowsModalBodyLabelProps = {
    label: string | undefined;
    href?: string;
    mobileLabel?: string;
    icon?: ReactNode;
    TypographyProps?: Partial<TypographyProps>;
    'data-testid'?: string;
};

/**
 * Label for DataRowsModalBody with logic to handle icons for mobile and mobile labels
 */
export const DataRowsModalBodyLabel = ({
    'data-testid': dataTestId,
    href,
    icon,
    label,
    mobileLabel,
    TypographyProps
}: DataRowsModalBodyLabelProps) => {
    const theme = useTheme();
    const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));

    const labelLeftPadding = isMobileScreen && icon ? 0.5 : 0;
    const labelContent = isMobileScreen && mobileLabel ? mobileLabel : label;

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {isMobileScreen && icon}
            {href ? (
                <Link
                    variant="body2"
                    component="a"
                    href={href}
                    underline="always"
                    target="_blank"
                    data-testid={slugify(labelContent || dataTestId || href)}
                    sx={{ pl: labelLeftPadding }}
                >
                    {labelContent}
                </Link>
            ) : (
                <Typography variant="body2" component="span" {...TypographyProps} sx={{ pl: labelLeftPadding }}>
                    {labelContent}
                </Typography>
            )}
        </Box>
    );
};
